export default "__VITE_ASSET__CxvYPaOi__"